import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useRootfileStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function RootFilesGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function RootFilesGridLayout() {
  return <GridProvider store={useRootfileStore()}>
    <RootFilesGrid />
  </GridProvider>
}
